export default "__VITE_ASSET__e1007d66__"